import React from "react";
import Picture from "../../../shared/components/Picture";
import { cardTypes, formatImageUrl } from "../../../shared/utils";
import { CardBackground } from "../../../shared/svg/Svg";
import { useReactAppState } from "../../../shared/containers/utils";
import { useLeaderCard } from "../../utils";
import ConditionalWrapper from "../../../shared/components/ConditionalWrapper";

function ClubLeaderCardFigure({ clubData }) {
  const { t, isLeague, urlList } = useReactAppState();
  const { baseUrl } = urlList || {};

  const { advertiser, header } = useLeaderCard();

  const { club } = clubData || {};
  const { name, logoColorUrl } = club || {};

  const { highQuality: clubLogoSrc } = logoColorUrl
    ? formatImageUrl(logoColorUrl, {
        format: "w_175,h_175,c_pad",
        extension: "f_png",
      })
    : {};

  return (
    <ConditionalWrapper
      condition={isLeague}
      wrapper={(children) => (
        <a
          alt={club.fullName}
          href={`${baseUrl}/clubs/${club.slug}`}
          style={{ "--aspect-ratio": "1.5" }}
          className="d3-o-media-object__figure--link"
        >
          {children}
        </a>
      )}
    >
      <figure
        className="d3-o-media-object__figure"
        style={{ "--aspect-ratio": "1.5" }}
      >
        {clubLogoSrc ? (
          <Picture
            src={clubLogoSrc}
            title={name ? name : t("fallback_logo")}
            extraClasses={cardTypes.club}
          />
        ) : null}
        <CardBackground extraClasses={"d3-o-media-object__background"} />
        <div className="d3-o-media-object__detail">
          <h3 className="d3-o-media-object__title">{header}</h3>
          {advertiser ? (
            <div role="complementary" className="d3-o-media-object__advertiser">
              <div className="d3-o-media-object__pres-by">
                {t("leader_card_presented_by")}
              </div>
              <div className="d3-o-media-object__adv">
                {advertiser ? (
                  <Picture
                    src={advertiser}
                    title={"Advertiser"}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </figure>
    </ConditionalWrapper>
  );
}

// eslint-disable-next-line no-func-assign
ClubLeaderCardFigure = React.memo(ClubLeaderCardFigure);

export default ClubLeaderCardFigure;
